import styled from 'styled-components';

export const Feedback = styled.p`
  margin: 0 16px;
  color: #e71037;
  font-size: 14px;
`;

export const IneligibleMessage = styled.div`
  color: #2e3958;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.45;
  text-align: center;

  p {
    margin: 0 0 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong {
    font-weight: 700;
  }
`;

export const RiskLegend = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin: -8px 8px 24px;
`;

export const RiskItems = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const RiskItem = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${({ $color }) => $color};
  font-size: 14px;
`;

export const RiskDot = styled.span<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const OvalTag = styled.span<{ $color: string; $background: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  background: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  vertical-align: middle;
`;

export const RiskSeparator = styled.span`
  width: 1px;
  height: 16px;
  background: #b7becb;
  flex-shrink: 0;
`;

export const RiskCopy = styled.div`
  text-align: left;
`;

export const RiskTitle = styled.p`
  margin: 0;
  color: #2e3958;
  font-size: 16px;
  font-weight: 700;
`;

export const RiskSubtitle = styled.p`
  margin: 4px 0 0;
  color: #757575;
  font-size: 13px;
`;

export const TableActions = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-top: 16px;
`;

export const SelectedBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const SelectedText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const SelectedCount = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;

export const SelectedName = styled.span`
  color: #e71037;
  font-size: 14px;
  font-weight: 700;
`;

export const BoxCard = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  margin-bottom: 24px;
`;
